import { assign, findIndex } from 'lodash';
import * as actions from '../constants';

export default (
  model: string,
  singularName: string,
  pluralName: string = model,
  extraConditions: any = {},
  extraState?: any,
) => {
  const actionNameSingular = singularName.toUpperCase();
  const actionNamePlural = pluralName.toUpperCase();

  const initialState = {
    isFetching: false,
    didInvalidate: false,
    error: false,
    [model]: [],
    lastUpdated: false,
    filtered: true,
    ...extraState,
  };

  return (state = initialState, action) => {
    let models = state[model];

    if (extraConditions[action.type]) {
      const extraConditionResult = extraConditions[action.type](
        state, action.data, action.error, action.id,
      );
      if (extraConditionResult !== false) {
        return extraConditionResult;
      }
    }

    switch (action.type) {

      case `${actions.REQUEST}_${actionNamePlural}`:
      case `${actions.REQUEST}_${actionNamePlural}_ALL`:
        return assign({}, state, {
          isFetching: true,
          error: false,
          didInvalidate: false,
          [model]: [],
        });

      case `${actions.REQUEST}_${actionNameSingular}`:
      case `${actions.REQUEST_ADD}_${actionNameSingular}`:
      case `${actions.REQUEST_UPDATE}_${actionNameSingular}`:
      case `${actions.REQUEST_REMOVE}_${actionNameSingular}`:
        return assign({}, state, {
          isFetching: true,
          error: false,
          didInvalidate: false,
        });

      case `${actions.RECEIVE_ADD}_${actionNameSingular}`: {
        return assign({}, state, {
          isFetching: false,
          [model]: action.error ? state[model] : [action.data, ...state[model]],
          error: action.error,
          didInvalidate: action.error !== false,
        });
      }

      case `${actions.RECEIVE}_${actionNameSingular}`:
      case `${actions.RECEIVE_UPDATE}_${actionNameSingular}`: {
        const entity = action.data;
        if (action.error === false && entity) {
          const index = findIndex(models, { id: action.id });
          const parentIndex = findIndex(models, { id: action.data.id });
          entity.lastUpdated = action.date;
          if (parentIndex !== -1) {
            models.splice(parentIndex, 1, entity);
          } else if (index !== -1) {
            models.splice(index, 1, entity);
          } else {
            models = [entity, ...models];
          }
        }
        return assign({}, state, {
          isFetching: false,
          didInvalidate: action.error !== false,
          error: action.error,
          [model]: models,
        });
      }

      case `${actions.RECEIVE}_${actionNamePlural}`:
      case `${actions.RECEIVE}_${actionNamePlural}_ALL`:
        return assign({}, state, {
          isFetching: false,
          [model]: action.error ? [] : action.data,
          error: action.error,
          didInvalidate: action.error !== false,
          lastUpdated: action.error ? state.lastUpdated : action.date,
        });

      case `${actions.RECEIVE_REMOVE}_${actionNameSingular}`: {
        if (action.error === false) {
          const index = findIndex(models, { id: action.id });
          models.splice(index, 1);
        }
        return assign({}, state, {
          isFetching: false,
          didInvalidate: action.error !== false,
          error: action.error,
          [model]: models,
        });
      }

      case `FILTER_${actionNamePlural}`:
        return assign({}, state, {
          filtered: !state.filtered,
        });

      case `SHOW_${actionNameSingular}_ERROR`:
        return assign({}, state, {
          didInvalidate: true,
          error: action.error,
        });

      case `CLEAR_${actionNameSingular}_ERRORS`:
        return assign({}, state, {
          didInvalidate: false,
          error: false,
        });

      default:
        return state;
    }
  };
};
